import React from "react";
import styles from "../labReportPdf.module.scss";

const PeripheralSmearPdf = ({ profile, PageBaseLayout, PageFooter }) => {
  return (
    <div className={styles.reportPage} style={{ pageBreakAfter: "always" }}>
      <PageBaseLayout
        showSampleType={true}
        currentSampleType={profile.sampleType}
      />
      <div className={styles.testCategoryHeader}>
        {profile?.profileName?.toUpperCase()}
      </div>

      <table className={styles.resultsTable}>
        <thead>
          <tr>
            <th style={{ width: "45%" }}>Test Description</th>
            <th style={{ textAlign: "center" }}>Value(s)</th>
            <th style={{ textAlign: "center" }}>Unit(s)</th>
            <th style={{ textAlign: "center" }}>Reference Range</th>
          </tr>
        </thead>
        <tbody>
          {profile?.tests?.map((t, idx) => (
            <tr key={idx}>
              <td style={{ verticalAlign: "top" }}>
                <strong>{t.testName}</strong>
              </td>
              <td
                align="left"
                style={{ whiteSpace: "pre-wrap", verticalAlign: "top" }}
              >
                {t.value || "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Technical Limitation Footer  */}
      {/* <div style={{ marginTop: "20px", fontSize: "11px", lineHeight: "1.4" }}>
        <p style={{ margin: 0 }}>
          The above results are subject to variations due to technical
          limitation. 
        </p>
        <p style={{ margin: 0 }}>
          Hence correlation with clinical findings and other investigations
          should be done.
        </p>
      </div> */}

      <PageFooter />
    </div>
  );
};

export default PeripheralSmearPdf;
